import { Component, effect, inject, NgZone, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TopBarComponent } from './main/top-bar/top-bar.component';
import { SideBarComponent } from './main/side-bar/side-bar.component';
import { Toast } from 'primeng/toast';
import { ProgressBar } from 'primeng/progressbar';
import { MessageService } from 'primeng/api';
import { LoadingComponent } from './core/components/loading/loading.component';
import { FooterComponent } from './main/footer/footer.component';
import Keycloak from 'keycloak-js';
import {
  KEYCLOAK_EVENT_SIGNAL,
  KeycloakEventType,
  ReadyArgs,
  typeEventArgs,
} from 'keycloak-angular';
import { AuthService } from '@core/service/auth.service';
import { AuthStore } from '@core/service/auth-store.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    TopBarComponent,
    SideBarComponent,
    FooterComponent,
    Toast,
    ProgressBar,
    LoadingComponent,
  ],
  providers: [MessageService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  styles: [
    `
      ::ng-deep .p-dropdown-label,
      ::ng-deep .p-dropdown-item,
      ::ng-deep .p-dropdown-header,
      ::ng-deep .p-dropdown-items .p-dropdown-item,
      ::ng-deep .p-dropdown-panel .p-dropdown-items,
      ::ng-deep .p-dropdown-filter,
      ::ng-deep .p-dropdown-clear-icon,
      ::ng-deep .p-selectitem {
        text-transform: uppercase !important;
      }
    `,
  ],
  standalone: true,
})
export class AppComponent {
  authService = inject(AuthService);
  private readonly keycloak = inject(Keycloak);
  private readonly keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);
  ngZone = inject(NgZone);
  authenticated = false;
  hasAccess: boolean = false;
  loading = true;
  authStore = inject(AuthStore);
  valueSpinner = signal(0);
  interval: any;
  intervalSpinner: any;

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  constructor() {
    effect(() => {
      const ev = this.keycloakSignal();

      if (
        ev.type === KeycloakEventType.Ready ||
        ev.type === KeycloakEventType.AuthSuccess ||
        ev.type === KeycloakEventType.AuthRefreshSuccess
      ) {
        this.authenticated = typeEventArgs<ReadyArgs>(ev.args);
        const token = this.keycloak.token ?? null;
        const parsed = this.keycloak.tokenParsed;

        this.authStore.setToken(token, true); // guarda token (sessionStorage)
        this.authStore.setFromTokenParsed(parsed, 'mirempet'); // guarda roles

        if (this.authenticated && parsed) {
          this.hasAccess = this.authService.userHasRole(parsed, [
            'admin_mirempet',
          ]);
          this.loading = false;
          if (!this.hasAccess) this.logout();
        }
      }

      if (ev.type === KeycloakEventType.AuthLogout) {
        this.authStore.setToken(null);
        this.authStore.setFromTokenParsed(undefined);
        this.authenticated = false;
      }
    });
  }

  // constructor() {

  //   effect(() => {
  //     const keycloakEvent = this.keycloakSignal();

  //     if (keycloakEvent.type === KeycloakEventType.Ready) {
  //       this.authenticated = typeEventArgs<ReadyArgs>(keycloakEvent.args);
  //       if (this.authenticated && this.keycloak.tokenParsed) {
  //         this.hasAccess = this.authService.userHasRole(this.keycloak.tokenParsed, ["admin_mirempet"]);
  //         this.loading = false;
  //         if (!this.hasAccess) {
  //           this.logout();
  //         }
  //       }
  //     }

  //     if (keycloakEvent.type === KeycloakEventType.AuthLogout) {
  //       this.authenticated = false;
  //     }
  //   });
  // }

  logout() {
    this.interval = setInterval(() => {
      this.keycloak.logout();
    }, 5000);
    setInterval(() => {
      this.valueSpinner.set(this.valueSpinner() + 1);
    }, 5000);
  }
}
